import { knearState, PreviewBlockPoint } from './knear-state';
import style from './knear.module.scss';
import StartSection from './sections/start-section';
import ProjectInfoSection from './sections/project-info-section';
import AccordionSection from './sections/accordion-section';
import BenefitsSection from './sections/benefits-section';
import TextSection from './sections/text-section';
import PreviewSection from './sections/preview-section';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import { Themes } from '@layouts/main-layout/themes.enum';

interface KnearProjectProps {
  breadcrumbsText: string;
}

const KnearComponent = ({ breadcrumbsText }: KnearProjectProps) => {
  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} theme={Themes.Dark} />
      <div className={style.knear}>
        <StartSection
          title={knearState.startBlock.title}
          subtitle={knearState.startBlock.subtitle}
          image={knearState.startBlock.image}
          text={knearState.startBlock.text}
        />
        <hr />
        <ProjectInfoSection title={knearState.projectInfoBlock.title} points={knearState.projectInfoBlock.points} />
        <hr />
        <TextSection title={knearState.storyBegins.title} text={knearState.storyBegins.text} />
        <hr />
        <AccordionSection title={knearState.accordion.title} items={knearState.accordion.items} />
        <hr />
        <TextSection title={knearState.benefitsArtist.title} text={knearState.benefitsArtist.text} />
        <hr />
        <BenefitsSection
          title={knearState.benefitsBuyer.title}
          points={knearState.benefitsBuyer.points}
          colorGray={false}
        />
        <hr />
        <BenefitsSection
          title={knearState.benefitsSeller.title}
          points={knearState.benefitsSeller.points}
          colorGray={true}
        />
        <hr />
        {knearState.previewBlocks.map((item: PreviewBlockPoint, index: number) => {
          return (
            <PreviewSection
              id={item.id}
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              image={item.image}
              points={item.points}
            />
          );
        })}
      </div>
    </>
  );
};

export default KnearComponent;
